import { Component, Injector, OnInit } from '@angular/core';
import { FormGenerico } from '../../generic/formgenerico/formgenerico';
import { GeralFormModule } from './geralform.module';
import { SuporteTecnico } from 'src/app/model/geral/suporteTecnico';
import { SuporteTecnicoService } from 'src/app/services/geral/suporte-tecnico.service';

@Component({
  selector: 'app-form-suporte-tecnico',
  templateUrl: '../../generic/formgenerico/formgenerico.component.html',
  styleUrls: [ '../../generic/formgenerico/formgenerico.component.css']
})

export class FormSuporteTecnicoComponent extends FormGenerico<SuporteTecnico> implements OnInit {

  constructor(
    injectorObj: Injector,
    api: SuporteTecnicoService) 
  {
    super(injectorObj, api);
    this.obj = new SuporteTecnico();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override dataExtraObj(res: any) {
  }

  protected onPropertyChange(propName: string, newValue: any): void {}
}
